import { Injectable } from '@angular/core';
import { HttpAuth } from '@core/services';
import { Store } from '@ngrx/store';
import { environment } from '@src/environments/environment';
import { userFeature } from '@src/state';
import { filter, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly url = `${environment.apiUrl}/api/msisdns/{msisdn}/storage`;

  constructor(
    private readonly httpAuth: HttpAuth,
    private readonly store: Store
  ) {}

  public getCloudStorageUrl() {
    return this.store.select(userFeature.selectSelectedMsisdnNumber).pipe(
      filter((msisdn) => !!msisdn),
      switchMap((msisdn) =>
        this.httpAuth.get<{ url: string }>(`${this.url.replace('{msisdn}', msisdn)}`)
      )
    );
  }

  public getStoragePrice() {
    return this.store.select(userFeature.selectSelectedMsisdnNumber).pipe(
      filter((msisdn) => !!msisdn),
      switchMap((msisdn) =>
        this.httpAuth.get<{ price: number }>(`${this.url.replace('{msisdn}', msisdn)}/info`)
      )
    );
  }
}
